import VerticalSeedHero from "./VerticalSeedHero";
import VerticalSeedProgram from "./VerticalSeedProgram";

class VerticalSeed {
    constructor() {
        this.init();
    }

    init() {
        this.heroEl = document.querySelector('.seed-hero');
        if(this.heroEl) {
            this.growthHeroGrid = new VerticalSeedHero(this.heroEl);
        }

        this.programEl = document.querySelector('.seed-program');
        if(this.programEl) {
            this.growthProgramGrid = new VerticalSeedProgram(this.programEl);
        }
    }
}

export default VerticalSeed
